import React from 'react'
import './Story.scss'
import couple from '../../img/story-1.jpeg'
import house from '../../img/story-2.jpeg'
export const Story = () => {
    return (
        <>
        <div className="story__pictures">
            <img src={couple} alt="par med nytt hus" className="story__img--1"></img>
            <img src={house} alt="nytt hus" className="story__img--2"></img>

        </div>

        <div className="story__content">
            <h3 className="heading-3 mb-sm">Nöjda Kunder</h3>
            <h2 className="heading-2 heading-2--dark mb-md">&ldquo;Bästa beslutet vi tagit &rdquo;</h2>
            <p className="story__text">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tenetur distinctio necessitatibus pariatur voluptatibus. Quidem consequatur harum volupta!
            </p>
            <button className="btn">Hitta ditt nya hem</button>
        </div>
        </>
    )
}
